import educatorService from "services/educatorService";

export const capitalizeFirstLetter = (word: string) => {
    if (!word) return "";
    return word.charAt(0).toUpperCase() + word.slice(1);
}

export const artifactReviewCounts =(artifacts: any) => {
    const count = artifacts.items.filter((obj: any) => {
        if (obj.comments.length === 0) return obj;
        const latestComment = obj.comments.filter((comm: any) => comm.user?.role === "ROLE_EDUCATOR")
        if(latestComment.length === 0){
          return obj;
        }
    })
    return count.length || 0
}

export  const getColorByTitle = (title: string) => {
    if (title.toLowerCase().includes('adapt')) return 'rgba(145, 149, 15, 1)';
    if (title.toLowerCase().includes('collaboration')) return 'rgba(0, 153, 150, 1)';
    if (title.toLowerCase().includes('comm')) return 'rgba(255, 136, 83, 1)';
    if (title.toLowerCase().includes('critical')) return 'rgba(112, 51, 183, 1)'
    if (title.toLowerCase().includes('empathy')) return 'rgba(77, 211, 254, 1)'; 
    if (title.toLowerCase().includes('learner')) return 'rgba(201, 13, 129, 1)'; 
    if (title.toLowerCase().includes('responsibility')) return 'rgba(255, 191, 73, 1)';
    
    return 'rgba(0, 82, 210, 1)';
  };

 
export const fetchLearnerSubs = async (
  emails: string[],
  userPoolId: string
): Promise<any | null> => {
  try {
    const subs = await educatorService.getLearnerSubs({
      emails,
      userPoolId,
    });

    return subs || null;
  } catch (error) {
    console.error("Error fetching learner subs:", error);
    return null;
  }
};

export const tintRgba = (rgba: string): string => {
  const [r, g, b] = rgba
    .replace("rgba(", "")
    .replace(")", "")
    .split(",")
    .slice(0, 3)
    .map(Number);

  const tintAmount = 0.9;

  const newR = Math.round(r + (255 - r) * tintAmount);
  const newG = Math.round(g + (255 - g) * tintAmount);
  const newB = Math.round(b + (255 - b) * tintAmount);

  return `rgba(${newR}, ${newG}, ${newB}, 1)`;
};